<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="100%"
		height="100%"
		viewBox="0 0 40 40"
		fill="none"
	>
		<path
			d="M11.5098 7.56136C10.8432 7.16632 10 7.64679 10 8.42164V31.5783C10 32.3532 10.8432 32.8337 11.5098 32.4387L31.0483 20.8603C31.7018 20.473 31.7018 19.527 31.0483 19.1397L11.5098 7.56136Z"
			fill="black"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.1471 6.486C12.1471 6.486 12.1471 6.486 12.1471 6.486L31.6856 18.0643C33.156 18.9358 33.1561 21.0641 31.6857 21.9356L12.1471 33.514C10.6472 34.4028 8.75 33.3217 8.75 31.5783V8.42164C8.75 6.67824 10.6472 5.59718 12.1471 6.486ZM11.25 8.86039L30.0482 20L11.25 31.1396V8.86039Z"
			fill="black"
		/>
	</svg>
</template>
